const PRODUCTION_BLOCKED_NAME_PATTERNS = [
  /^gold\s+for\s+test$/i,
  /^123asdf$/i,
  /^test\s*data$/i,
  /^sample\s+data$/i,
  /^demo\s+account$/i,
  /^test\s+bank\b/i,
  /^qa\s+test\b/i,
  /\bdelete\s+me\b/i,
  /^\[asset\]$/i,
  /^test\s+goal$/i,
  /^first\s+test\s+goal$/i,
  /^goal\s+from\s+main\s+dash$/i,
  /^goal\s+form\s+dash$/i,
  /^goal\s+for\s+dashboard$/i,
  /^notification\s+checking$/i,
  /^test\s+family$/i,
];

const PRODUCTION_BLOCKED_EMAIL_PATTERNS = [/^test@/i, /^demo@/i, /^qa\+/i, /\+test@/i];

export function isProductionEnv() {
  const nodeEnv = (process.env.NODE_ENV || "").toLowerCase();
  const appEnv = (process.env.APP_ENV || "").toLowerCase();
  return nodeEnv === "production" || appEnv === "production";
}

export function isBlockedTestLabel(value) {
  const normalized = (value || "").trim();
  if (!normalized) return false;
  return PRODUCTION_BLOCKED_NAME_PATTERNS.some((pattern) => pattern.test(normalized));
}

export function isBlockedTestEmail(email) {
  const normalized = (email || "").trim().toLowerCase();
  if (!normalized) return false;
  return PRODUCTION_BLOCKED_EMAIL_PATTERNS.some((pattern) => pattern.test(normalized));
}

export function validateProductionUserContent(payload) {
  if (!isProductionEnv()) {
    return { allowed: true };
  }

  const fieldsToCheck = [payload.name, payload.title, payload.organization_name];
  for (const field of fieldsToCheck) {
    if (isBlockedTestLabel(field)) {
      return {
        allowed: false,
        reason: "Test or demo labels are not allowed in production",
      };
    }
  }

  if (isBlockedTestEmail(payload.email)) {
    return {
      allowed: false,
      reason: "Test email addresses are not allowed in production",
    };
  }

  return { allowed: true };
}
